<template>
    <local-tree-view ref="treeRef" :data-source="items" :meta="meta" @item-click="onItemClick">
        <template #items-template="{ data }">
            <div class="flex items-center">
                <div class="w-1/4 px-2 flex">
                    <img :src="`/infoenergo/assets/${data.type === 'g' ? 'folder' : 'table'}.svg`" />
                    <span>{{ data.name }}</span>
                </div>
                <div class="w-3/4 px-2">
                    {{ data.info }}
                </div>
            </div>
        </template>
        <template #item-template="{ data }">
            <div class="flex items-center gap-2">
                <img :src="`/infoenergo/assets/${data.type === 'g' ? 'folder' : 'table'}.svg`" />
                {{ data.name }}
            </div>
        </template>
    </local-tree-view>
</template>

<script setup>
import { ref, defineEmits, onMounted } from 'vue';

import LocalTreeView from '@/components/local-tree-view.vue';
import { api } from '@/service/http';

const treeRef = ref();
const treeInstance = ref();
const items = ref([]);
const selectedItems = ref([]);

defineProps({
    dataSource: {
        type: Array,
        default: () => [],
    },
    meta: {
        type: Object,
        default: () => {
            return {
                searchHint: null,
                valueChangeEvent: 'keyup',

                keyExpr: 'key',
                displayExpr: 'name',
                parentIdExpr: 'parent_id',

                rootValue: null,
                dataStructure: 'plain',
                selectByClick: true,
                expandEvent: 'dblclick',
                selectionMode: 'single',
                itemTemplate: 'item-template',
            };
        },
    },
});

const emit = defineEmits(['WhereChangeActive']);

onMounted(async () => {
    await initData();
    treeInstance.value = treeRef.value.treeViewInstance;
});

const initData = async () => {
    try {
        const response = await api('core./history/tab-groups/get', { is_plain: true });
        items.value = response.data;
    } catch (error) {
        items.value = [];
        return {
            result: false,
            error: error.message,
            uuid: 'f75afcc2-d866-4d68-897b-df9afed1d986',
        };
    }
};

const onItemClick = event => {
    emit('WhereChangeActive', event.itemData);
    selectedItems.value = [event.itemData];
};

const selectNode = key => {
    if(key){
        treeInstance.value.expandItem(key);
        treeInstance.value.selectItem(key);
    }
}

defineExpose({
    data: items,
    selectedItems,
    selectNode,
});
</script>

<style scoped>
img {
    width: 25px;
    height: 25px;
    margin-right: 10px;
}
</style>
